import { ChangeEvent, FC, useState } from 'react';

import Flex from 'quarks/Flex';
import Text from 'quarks/Text';
import type { FlexProps } from 'quarks/interpolations/flex';

import TextField from 'molecules/TextField/TextField';

import ComponentButton from 'components/Button/ComponentButton';

import type { ContentfulComponentForm } from 'graphqlTypes';

interface FormProps
  extends FlexProps,
    Omit<ContentfulComponentForm, 'id' | 'children' | 'contentful_id' | 'internal' | 'node_locale'> {
  backgroundIsDark?: boolean;
}

const BasicForm: FC<FormProps> = () => {
  const [validated, setValidated] = useState(false);
  const [prefix, setPrefix] = useState('');
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPrefix(e.target.value);
  };
  const handleSubmit = () => {
    if (!prefix) {
      setValidated(true);

      return false;
    }
    window.open(`https://${prefix}.fieldroutes.com`, '_blank', 'noreferrer');
  };

  return (
    <Flex width="100%" flexDirection="column" gap="16px">
      <Text textStyle="textSm" textColor="gray-900">
        {prefix || '###'}.fieldroutes.com
      </Text>
      <Flex
        width="100%"
        flexDirection="column"
        gap="16px"
        md={{ flexDirection: 'row', gap: '0px' }}
        css={`
          .MuiInputBase-root {
            border-radius: 0;
          }
        `}
      >
        <TextField
          type="text"
          placeholder="Company Sub Domain"
          name="fname"
          required
          width="100%"
          onChange={handleChange}
          submitValidation={validated}
        />
        <Flex
          flexDirection="column"
          css={`
            .MuiButton-root {
              min-width: 200px !important;
              min-height: 48px !important;
              border-radius: 0;
              max-width: 100% !important;
            },
          `}
          onClick={() => handleSubmit()}
        >
          <ComponentButton label="Go to Login Page" isButton />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BasicForm;
